module.exports = __webpack_public_path__ + "img/home.f5619a4e.svg";